module.exports = "../img/video-technical-reasons-1cnct3w.jpg";